// extracted by mini-css-extract-plugin
export default {"header":"NotificationList_header__7MvcS","shareApp":"NotificationList_shareApp__YiELA"};